export const getNameInitials = (name: string, prefix?: string) => {
  if (!name) {
    return '';
  }
  const arr = name.includes('.')
    ? name.split('.').filter((el) => el)
    : name.split(' ').filter((el) => el);

  if (arr.length > 1) {
    return `${arr[0]?.substring(0, 1)}${arr[1]?.substring(0, 1)}${
      prefix ? prefix + '' : ''
    }`;
  } else {
    return `${arr[0]?.substring(0, 1)}${prefix ? prefix + '' : ''}`;
  }
};
